import { render, staticRenderFns } from "./SecondaryContent.vue?vue&type=template&id=2ef029d6&scoped=true&"
import script from "./SecondaryContent.vue?vue&type=script&lang=js&"
export * from "./SecondaryContent.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryContent.vue?vue&type=style&index=0&id=2ef029d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef029d6",
  null
  
)

export default component.exports